<app-spinner [isLoading]="isLoading$ | async">
  <div
    *ngIf="{
      announcementDetails: announcementDetails$ | async,
      announcementNotFound: announcementNotFound$ | async,
      similarAnnouncements: similarAnnouncementList$ | async,
      favoriteAnnouncementsMap: favoriteAnnouncementsMap$ | async,
      socialMediaShareLinks: socialMediaShareLinks$ | async,
      timeZone: timeZone$ | async,
      topBanner: topBanner$ | async,
      rightBanner: rightBanner$ | async,
      rightBanner2: rightBanner2$ | async,
      rightBanner3: rightBanner3$ | async,
      rightBannerSquare: rightBannerSquare$ | async,
      middleBanner: middleBanner$ | async,
      bottomBanner: bottomBanner$ | async,
      isJobseekerSignedIn: isJobseekerSignedIn$ | async,
      isCustomerSignedIn: isCustomerSignedIn$ | async,
      isJobseekerInvited: isJobseekerInvited$ | async,
      announcementInvitedJobseeker: announcementInvitedJobseeker$ | async,
      isSignedIn: isSignedIn$ | async,
      user: user$ | async,
      isAnnouncementLinkCopied: isAnnouncementLinkCopied$ | async,
      isLoading: isLoading$ | async,
      announcementViewStats: announcementViewStats$ | async,
      isCvBoxSliderVisible: isCvBoxSliderVisible$ | async,
      desktopImage: desktopImage$ | async,
      mobileImage: mobileImage$ | async,
      ownAnnouncements: ownAnnouncements$ | async,
      currency: currency$ | async,
      currentLanguage: currentLanguage$ | async,
      previousAnnouncementId: previousAnnouncementId$ | async,
      nextAnnouncementId: nextAnnouncementId$ | async,
      userType: userType$ | async
    } as data"
  >
    <div
      class="container"
      [ngStyle]="
        !data.isLoading &&
        data.announcementDetails?.isWithBranding &&
        data.announcementDetails.customerBranding?.announcementDetailsBgColor !=
          null
          ? {
              background:
                data.announcementDetails.customerBranding
                  ?.announcementDetailsBgColor
            }
          : {}
      "
    >
      <div
        *ngIf="
          data.announcementDetails != null &&
          !data.isLoading &&
          !data.announcementDetails?.expired &&
          !data.announcementNotFound
        "
      >
        <!--Banner Top-->
        <div class="banner banner--top">
          <div class="banner">
            <app-banner
              [banner]="data.topBanner"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>
        </div>

        <div class="container--left">
          <div
            [ngClass]="{
              'logo-container--with-cover':
                (targetId === target.Responsive && data.mobileImage != null) ||
                (targetId === target.Desktop && data.desktopImage != null),
              'logo-container--without-imgs':
                ((targetId === target.Responsive && data.mobileImage == null) ||
                  (targetId === target.Desktop && data.desktopImage == null)) &&
                !data.announcementDetails?.hasLogo
            }"
            class="logo-container"
          >
            <div class="chevrons--left">
              <a
                [routerLink]="routerLink$ | async"
                [queryParams]="queryParams$ | async"
                class="back"
              >
                <svg-icon
                  class="back__icon"
                  src="/assets/icons/chevron-left-green.svg"
                  [svgClass]="'chevron'"
                  [ngClass]="{
                    'with-branding--icon':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                </svg-icon>
                <span
                  class="back__text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{ 'label.BackToSearchResults' | translate }}
                </span>
              </a>
            </div>

            <div class="imgs">
              <div
                *ngIf="
                  (targetId === target.Responsive &&
                    data.mobileImage != null) ||
                  (targetId === target.Desktop && data.desktopImage != null)
                "
                class="cover"
                [ngStyle]="{
                  'background-image':
                    targetId === target.Responsive
                      ? 'url(' + data.mobileImage + ')'
                      : 'url(' + data.desktopImage + ')'
                }"
              ></div>
              <div
                class="logo"
                [ngClass]="{
                  'logo--with-cover':
                    (targetId === target.Responsive &&
                      data.mobileImage != null) ||
                    (targetId === target.Desktop && data.desktopImage != null)
                }"
                *ngIf="data.announcementDetails?.hasLogo"
              >
                <img
                  class="logo__img"
                  [src]="data.announcementDetails?.logoUrl"
                  alt=""
                />
              </div>
            </div>

            <div class="chevrons--right" style="display: flex">
              <a
                *ngIf="data.previousAnnouncementId != null; else elseAnnIsFirst"
                [routerLink]="[
                  '/announcement',
                  data.previousAnnouncementId.announcementId,
                  translit.getUrlFriendlyString(
                    data.previousAnnouncementId.announcementTitle
                  )
                ]"
                [queryParams]="{ nav: 1 }"
                class="previous"
              >
                <svg-icon
                  class="previous__icon"
                  src="/assets/icons/chevron-left-green.svg"
                  [svgClass]="'chevron'"
                  [ngClass]="{
                    'with-branding--icon':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                </svg-icon>
                <span
                  class="previous__text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{ 'label.previous' | translate }}
                </span>
              </a>
              <ng-template #elseAnnIsFirst>
                <div class="previous">
                  <svg-icon
                    class="previous__icon"
                    src="/assets/icons/chevron-left-green.svg"
                    [svgClass]="'chevron'"
                    [ngClass]="{
                      'with-branding--icon':
                        data.announcementDetails?.isWithBranding &&
                        data.announcementDetails.customerBranding
                          ?.announcementDetailsBgColor != null
                    }"
                  >
                  </svg-icon>
                  <span
                    class="previous__text inactive-link"
                    [ngClass]="{
                      'with-branding--text':
                        data.announcementDetails?.isWithBranding &&
                        data.announcementDetails.customerBranding
                          ?.announcementDetailsBgColor != null
                    }"
                  >
                    {{ 'label.previous' | translate }}
                  </span>
                </div>
              </ng-template>

              <a
                *ngIf="data.nextAnnouncementId != null; else elseAnnIsLast"
                [routerLink]="[
                  '/announcement',
                  data.nextAnnouncementId.announcementId,
                  translit.getUrlFriendlyString(
                    data.nextAnnouncementId.announcementTitle
                  )
                ]"
                [queryParams]="{ nav: 1 }"
                class="next"
              >
                <span
                  class="next__text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{ 'label.Next' | translate }}
                </span>
                <svg-icon
                  class="next__icon"
                  src="/assets/icons/chevron-right-green.svg"
                  [svgClass]="'chevron'"
                  [ngClass]="{
                    'with-branding--icon':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                </svg-icon>
              </a>
              <ng-template #elseAnnIsLast>
                <div class="next">
                  <span
                    class="next__text inactive-link"
                    [ngClass]="{
                      'with-branding--text':
                        data.announcementDetails?.isWithBranding &&
                        data.announcementDetails.customerBranding
                          ?.announcementDetailsBgColor != null
                    }"
                  >
                    {{ 'label.Next' | translate }}
                  </span>
                  <svg-icon
                    class="next__icon"
                    src="/assets/icons/chevron-right-green.svg"
                    [svgClass]="'chevron'"
                    [ngClass]="{
                      'with-branding--icon':
                        data.announcementDetails?.isWithBranding &&
                        data.announcementDetails.customerBranding
                          ?.announcementDetailsBgColor != null
                    }"
                  >
                  </svg-icon>
                </div>
              </ng-template>
            </div>
          </div>
          <hrra-announcement-details-tile
            [announcementDetails]="data.announcementDetails"
            [publishDate]="publishDate$ | async"
            [timeZone]="data.timeZone"
            [currentLanguage]="data.currentLanguage"
            [currentUserType]="data.userType"
            [user]="data.user"
            [isSignedIn]="data.isSignedIn"
            [isJobseekerSignedIn]="data.isJobseekerSignedIn"
            [isJobseekerInvited]="data.isJobseekerInvited"
            [announcementInvitedJobseeker]="data.announcementInvitedJobseeker"
            [showInviteResponse]="data.isJobseekerInvited === true"
            [isPublicView]="true"
            [isFavorite]="
              data.favoriteAnnouncementsMap[
                data.announcementDetails?.announcementId
              ] === true
            "
            [isAnnouncementLinkCopied]="data.isAnnouncementLinkCopied"
            [socialMediaShareLinks]="data.socialMediaShareLinks"
            [providerWebsiteId]="providerWebsiteId"
            (cvSend)="
              onCvSend($event, data.isSignedIn, data.isJobseekerSignedIn)
            "
            (toggleFavorite)="
              onToggleFavorite(data.announcementDetails?.announcementId, $event)
            "
            (externalApply)="
              redirectToUrl(
                data.isJobseekerSignedIn,
                data.announcementDetails?.hasCaptureCv,
                $event
              )
            "
            (copyLink)="copyCurrentRoute()"
            (socialShare)="shareOnSocialMedia($event)"
            (inviteRespond)="onInviteRespond($event)"
          ></hrra-announcement-details-tile>

          <div class="categories-section">
            <div
              *ngFor="
                let headSpecialization of data.announcementDetails
                  ?.announcementRequirements?.specializationList
              "
              class="categories"
            >
              <div
                (click)="onSpecializationClick(headSpecialization.code)"
                class="categories__head-categories"
                [ngClass]="{
                  'with-branding--text-header':
                    data.announcementDetails?.isWithBranding &&
                    data.announcementDetails.customerBranding
                      ?.announcementDetailsBgColor != null
                }"
              >
                {{ headSpecialization.name }}
              </div>
              <svg-icon
                class="categories__icon"
                [src]="
                  data.announcementDetails?.isWithBranding &&
                  data.announcementDetails.customerBranding
                    ?.announcementDetailsBgColor != null
                    ? '/assets/icons/chevron-right-white.svg'
                    : '/assets/icons/chevron-right-black.svg'
                "
                [ngClass]="{
                  'with-branding--icon':
                    data.announcementDetails?.isWithBranding &&
                    data.announcementDetails.customerBranding
                      ?.announcementDetailsBgColor != null
                }"
              >
              </svg-icon>
              <div class="categories__subcategories">
                <div
                  *ngFor="
                    let specialization of headSpecialization.children;
                    let last = last
                  "
                  (click)="onSpecializationClick(specialization.code)"
                  class="categories__subcategory"
                  [ngClass]="{
                    'with-branding--text-sub':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{ specialization.name }}{{ last ? '' : ',' }}
                </div>
              </div>
            </div>
          </div>

          <div class="stats">
            <div class="stats__views stats__item">
              <div>
                <svg-icon src="/assets/icons/views.svg"></svg-icon>
              </div>
              <div>
                <span
                  class="stats__text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{ 'label.Views' | translate }}
                </span>
                <span
                  class="stats__count-text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{
                    data.announcementViewStats?.totalViewsOnWebsite !== null
                      ? data.announcementViewStats.totalViewsOnWebsite
                      : ''
                  }}
                </span>
              </div>
            </div>
            <div class="stats__unique-views stats__item">
              <div>
                <svg-icon src="/assets/icons/unique-views.svg"></svg-icon>
              </div>
              <div>
                <span
                  class="stats__text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{ 'label.UniqueViews' | translate }}
                </span>
                <span
                  class="stats__count-text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{
                    data.announcementViewStats?.uniqueViewsOnWebsite !== null
                      ? data.announcementViewStats?.uniqueViewsOnWebsite
                      : ''
                  }}
                </span>
              </div>
            </div>
            <div
              class="stats__sent-cvs stats__item"
              *ngIf="
                data.announcementDetails?.applicationMethod ==
                applicationMethod.ViaWebsite
              "
            >
              <div>
                <svg-icon src="/assets/icons/sent-cvs.svg"></svg-icon>
              </div>
              <div>
                <span
                  class="stats__text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{ 'label.SentCvs' | translate }}
                </span>
                <span
                  class="stats__count-text"
                  [ngClass]="{
                    'with-branding--text':
                      data.announcementDetails?.isWithBranding &&
                      data.announcementDetails.customerBranding
                        ?.announcementDetailsBgColor != null
                  }"
                >
                  {{ data.announcementDetails?.totalApplicationsOnWebsite }}
                </span>
              </div>
            </div>
          </div>

          <!--Banner middle-->
          <div class="banner">
            <app-banner
              [banner]="data.middleBanner"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>
        </div>

        <div class="container--right">
          <!--Banner right-->
          <div class="banner banner--right3">
            <app-banner
              [banner]="data.rightBanner3"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>

          <div class="banner">
            <app-banner [banner]="data.rightBanner"></app-banner>
          </div>

          <div class="banner">
            <app-banner
              [banner]="data.rightBanner2"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>

          <!--own announcements-->
          <div
            class="own-announcements"
            *ngIf="
              data.announcementDetails?.isWithBranding &&
              data.announcementDetails?.customerBranding
                .announcementDetailsDisplayOtherAnnouncements &&
              data.ownAnnouncements.length > 0
            "
          >
            <div
              class="own-announcements__text"
              [ngClass]="{
                'with-branding--text':
                  data.announcementDetails?.isWithBranding &&
                  data.announcementDetails.customerBranding
                    ?.announcementDetailsBgColor != null
              }"
            >
              {{ 'label.OwnAnnouncements' | translate }}
            </div>

            <div
              *ngFor="let ownAnnouncement of data.ownAnnouncements"
              class="own-announcements__item"
            >
              <app-similar-ann-item
                [similarAnnouncement]="ownAnnouncement"
              ></app-similar-ann-item>
            </div>
          </div>

          <!--Cv Box-->
          <div
            *ngIf="
              data.announcementDetails?.isWithBranding &&
              data.announcementDetails.isWithCvBox
            "
            class="cv-box-container"
          >
            <h2 class="cv-box-container__title">
              {{ 'label.CvBox' | translate }}
            </h2>
            <div class="cv-box-container__text">
              {{ 'label.LeaveCvOffer' | translate }}
            </div>

            <app-cv-box-item
              [cvBox]="data.announcementDetails?.customerCvBox"
              [userType]="userType$ | async"
            ></app-cv-box-item>
          </div>

          <div
            *ngIf="data.similarAnnouncements?.length > 0"
            class="similar-ann"
          >
            <div
              [ngClass]="{
                'similar-ann--without-top-banner':
                  data.rightBanner == null && data.rightBanner2 == null,
                'with-branding--text':
                  data.announcementDetails?.isWithBranding &&
                  data.announcementDetails.customerBranding
                    ?.announcementDetailsBgColor != null
              }"
              class="similar-ann__text"
            >
              {{ 'label.SimilarAnnouncements' | translate }}
            </div>
            <div
              *ngFor="let similarAnnouncement of data.similarAnnouncements"
              class="similar-ann__item"
            >
              <app-similar-ann-item
                [similarAnnouncement]="similarAnnouncement"
              ></app-similar-ann-item>
            </div>
          </div>

          <!--Banner right -->
          <div class="banner">
            <app-banner
              [banner]="data.rightBannerSquare"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>
        </div>

        <div class="cv-box-slider-container">
          <div *ngIf="data.isCvBoxSliderVisible" class="cv-box-slider">
            <owl-carousel-o [options]="cvBoxSliderOptions" class="carousel">
              <ng-container *ngFor="let cvBox of cvBoxes$ | async">
                <ng-template carouselSlide [id]="cvBox.customerId">
                  <app-cv-box-item
                    ngxSlickItem
                    [cvBox]="cvBox"
                    class="cv-box-slider__item"
                    [userType]="userType$ | async"
                  ></app-cv-box-item>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </div>

        <div style="clear: both"></div>

        <!--Banner bottom-->
        <div class="banner banner">
          <app-banner
            [banner]="data.bottomBanner"
            [pageId]="pageId.AnnouncementDetailsPage"
          ></app-banner>
        </div>
      </div>

      <div
        *ngIf="data.announcementNotFound || data.announcementDetails?.expired"
        class="unavailable-ann"
      >
        <app-not-existing-page
          [errorType]="errorType.NotAvailable"
          [hideDefaultMessage]="true"
        ></app-not-existing-page>

        <h4 class="unavailable-ann__title">
          {{ 'message.AnnouncementExpiredOrDoesNotExist' | translate }}
        </h4>
        <br />

        <div *ngIf="data.similarAnnouncements?.length > 0" class="expired-ann">
          <h4 class="expired-ann__text">
            {{ 'label.YouMayInterest' | translate }}:
          </h4>

          <div class="expired-similar-ann-container">
            <div
              *ngFor="let announcement of data.similarAnnouncements"
              class="expired-similar-ann"
            >
              <div class="expired-similar-ann__title">
                <a
                  class="expired-similar-ann__title-link"
                  [routerLink]="['/announcement', announcement?.announcementId]"
                  >{{ announcement?.title }}</a
                >
              </div>
              <div class="expired-similar-ann__company-name">
                {{ announcement?.customerName }}
              </div>
              <div class="expired-similar-ann__dates">
                {{
                  announcement?.publishDate
                    | date: 'dd MMM':data.timeZone:data.currentLanguage
                }}
                -
                {{
                  announcement?.deadlineDate
                    | date: 'dd MMM':data.timeZone:data.currentLanguage
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-spinner>
